import { BibTipoUsuarioModel } from "@/models/biblioteca/bibtipousuario/bibtipousuario.model";

export class BibEmprestimoModel {
 bibEmprestimoId? :number =  0;
 bibExemplarId? :number =  0;
 bibTipoUsuario? :BibTipoUsuarioModel | null = null;
 titulo? :string = '';
 autoria? :string = ''; 
 segUsuarioId? :number =  0;
 bibTipoUsuarioId? :number =  0;
 prazoEmprestimo? :number =  0;
 moraAtraso? :number =  0;
 especial? :number =  0;
 dataEmprestimo? :Date;
 dataVencimento? :Date;
 dataDevolucao? :Date;
 multa? :number =  0;
 tipoEmprestimo? :number =  0;
 devolvido? :number =  0;
 multaPaga? :number =  0;
 dispensaMulta? :number =  0;
 bibMotivoDispensaId? :number =  0;
 situacao? :number =  0;
 observacao? :string =  '';
 renovacoes? :number =  0;
 gesEscolaId? :number =  0;
 emprestado? :boolean = false;
 
}
